/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_1_PickInputs */

const en_pc_alt_pick_1_pick = /** @type {(inputs: Pc_Alt_Pick_1_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with PdfCraft. It is free on every desktop, and you can try PdfCraft Online first without installing anything.`)
};

const zh_pc_alt_pick_1_pick = /** @type {(inputs: Pc_Alt_Pick_1_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先试 PdfCraft。它在所有桌面系统上免费，也可以先用 PdfCraft 在线版试用，无需安装。`)
};

/**
* | output |
* | --- |
* | "Start with PdfCraft. It is free on every desktop, and you can try PdfCraft Online first without installing anything." |
*
* @param {Pc_Alt_Pick_1_PickInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_1_pick = /** @type {((inputs?: Pc_Alt_Pick_1_PickInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_1_PickInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_1_pick(inputs)
	return zh_pc_alt_pick_1_pick(inputs)
});
export { pc_alt_pick_1_pick as "pc.alt.pick.1.pick" }